import React from "react";
import { CSVLink } from "react-csv";
import "./ExportExcelButton.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv, faGear, fas } from '@fortawesome/free-solid-svg-icons'

const ExportExcelButton = (props) => {
  return (
    <div  className="excel-button">
      <CSVLink
        style={{ textDecoration: "none"}}
        filename={props.filename}
       
        data={props.data}
        onClick={props.onClick}
        separator={";"}
        target="_blank"
      >
        <span style={{color:'white',fontSize:'inherit'}}><FontAwesomeIcon icon={faFileCsv}/>{" Exportar"}</span>
      </CSVLink>
    </div>
  );
};

export default ExportExcelButton;